import componentStyle from "./component.module.scss";

import React, { useEffect, useRef, useState } from "react";
import { useTheme } from "@mui/material/styles";

const isValidMacSegment = (str) => /^[0-9A-F]{0,2}$/i.test(str);

const MacInputField = ({
  value = "",
  onChange,
  disabled = false,
  separator = "-",
  showError = false, // parent controls red border
  onPaste
}) => {
  const theme = useTheme();
  const inputRefs = useRef([]);
  const [segments, setSegments] = useState(["", "", "", "", "", ""]);

  const inputStyle = {
    width: "28px",
    height: "28px",
    textAlign: "center",
    textTransform: "uppercase",
    fontSize: "14px",
    fontFamily: "monospace",
    border: `0px solid ${theme.palette.primary.greyThread}`,
    borderRadius: "4px",
    outline: "none",
    padding: "2px",
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
  };

  const sepStyle = {
    fontSize: "14px",
    fontFamily: "monospace",
    userSelect: "none",
    color: theme.palette.text.primary,
  };

  // When user types into a segment
  const handleChange = (val, index) => {
    if (disabled) return;

    const cleaned = val.toUpperCase().replace(/[^0-9A-F]/g, "");
    if (!isValidMacSegment(cleaned)) return;

    const next = [...segments];
    next[index] = cleaned;
    setSegments(next);

    const macStr = next.map((seg) => seg.padEnd(2, "")).join(separator);
    onChange?.(macStr);

    if (cleaned.length === 2 && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (disabled) return;

    if (e.key === "Backspace" && segments[index] === "" && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  // Format parent value → internal segments
  useEffect(() => {
    if (!value) {
      setSegments(["", "", "", "", "", ""]);
      return;
    }

    // Convert to an array "------" → ["AA", "BB", "CC", "DD", "EE", "FF"]
    const ary = value.split(separator);
    const parts = ['', '', '', '', '', ''];
    for (let i = 0; i < ary.length; i++) {
      const cleaned = ary[i].toUpperCase().replace(/[^0-9A-F]/g, "");
      parts[i] = cleaned.slice(0, 2);
    }

    setSegments(parts);
  }, [value, separator]);

  return (
    <div className={`${componentStyle["mac-wrapper"]} ${showError ? componentStyle.error : ""}`}>
      {segments.map((seg, index) => (
        <React.Fragment key={index}>
          <input
            type="text"
            maxLength={2}
            ref={(el) => (inputRefs.current[index] = el)}
            value={seg}
            onChange={(e) => handleChange(e.target.value, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={onPaste}
            style={inputStyle}
          />
          {index < 5 && <span style={sepStyle}>{separator}</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default React.memo(MacInputField);